<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">会员名称：</div>
          <el-input v-model="page.tenantName" class="ipt-sty w70f" placeholder="请输入会员名称"></el-input
        ></el-col>
        <el-col :span="8"
          ><div class="search-area-div">算法名称：</div>
          <el-select v-model="page.repositoryGuid" placeholder="请选择算法名称" class="w70f" filterable>
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
          </el-col>
        <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">算法分配</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="tenantName" label="会员名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="repositoryName" label="算法名称" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="parameter" label="参数名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="defaultValue" label="初始值" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column prop="createTime" label="前置条件" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column> -->
        <el-table-column prop="state" label="状态" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.state == 'Y'?'有效':'停用' }}</template>
        </el-table-column>  
        <el-table-column prop="updateUserName" label="修改人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="updateTime" label="修改时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="parameterSet(scope.row)">参数设置 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog
    title="参数设置"
    :visible.sync="dialogVisible"
    width="40%">
    <span>{{parameterSetTitle}}：</span>
    <!-- <el-input v-model="input" placeholder="请输入正整数" class="w49f"></el-input> -->
     <el-input-number v-model="ruleForm1.value" :precision="0" :min="1" class="w49f"  v-if="valueType == '1'">> </el-input-number>
    <el-date-picker
      v-model="ruleForm1.time"
      type="daterange"
      v-if="valueType == '6'" class="w49f"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-select v-model="ruleForm1.value" filterable placeholder="请选择商品名称" class="w49f" v-if="valueType == '3' && parameterSetTitle == '商品名称'">
      <el-option 
        v-for="(item,index) in goodsList"
        :key="index"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm1.value" filterable placeholder="请选择周期类型" class="w49f" v-if="valueType == '3' && parameterSetTitle == '周期类型'">
      <el-option
        v-for="item in cycleList"
        :key="item.value" 
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm1.city" filterable placeholder="请选择城市" multiple collapse-tags  class="w49f" v-if="valueType == '4' && parameterSetTitle == '总仓所在城市' || valueType == '4' && parameterSetTitle == '指定RDC备选城市'">
      <el-option
        v-for="item in cityList"
        :key="item.value" 
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-select v-model="ruleForm1.city" filterable placeholder="请选择省份" multiple collapse-tags  class="w49f"  v-if="valueType == '4' && parameterSetTitle == '总仓覆盖的省份' || valueType == '4' && parameterSetTitle == '排除的省(不作为RDC的考虑范围)'">
      <el-option
        v-for="item in provinceList"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-input v-model="ruleForm1.value" class="ipt-sty w49f" placeholder="请输入药企名称"  v-if="valueType == '8'"></el-input> 
    <span slot="footer" class="dialog-footer">
    <el-button  plain size="medium" @click="dialogVisible = false">取 消</el-button>
    <el-button size="medium" type="info" @click="upDateForm1()">确 定</el-button>
    </span>
    </el-dialog>


    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      > 
      <el-form-item label="会员名称:" prop="tenantGuid"> 
          <el-select v-model="ruleForm.tenantGuid" placeholder="请选择" class="w100f" filterable>
            <el-option
              v-for="item in tenantList"
              :key="item.guid"
              :label="item.tenantName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="算法名称:" prop="repositoryGuid"> 
          <el-select v-model="ruleForm.repositoryGuid" placeholder="请选择" class="w100f" filterable @change="getparameterList(ruleForm.repositoryGuid)">
            <el-option
              v-for="item in repositoryNameList"
              :key="item.guid"
              :label="item.repositoryName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参数配置:" prop="parameterGuid">
          <el-select v-model="ruleForm.parameterGuid" placeholder="请选择" multiple  filterable class="w100f">
            <el-option
              v-for="item in parameterList"
              :key="item.guid"
              :label="item.parameter"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> 
        <el-form-item label="状态:" class="t-left">
          <el-radio v-model="ruleForm.state" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.state" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '算法分配添加'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm1: {
        guid: '',
        tenantGuid: '',
        tenantName: '', 
        parameterGuid: '',
        parameter:'',
        repositoryGuid: [],
        repositoryName:'',
        parameterList:[],
        state:'Y',
        city:[],
        value:'',
      },
      ruleForm: {
        guid: '',
        tenantGuid: '',
        tenantName: '', 
        parameterGuid: '',
        parameter:'',
        repositoryGuid: [],
        repositoryName:'',
        parameterList:[],
        state:'Y'
      },
      cycleList:[{value:'周',label:'周'},{value:'月',label:'月'}],
      goodsList:[],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '',
        parameterGuid:'',
        tenantGuid: '', 
        repositoryName: '',
        parameter:'', 
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '',
      },
      tableData: [],
      rules: { 
          tenantGuid: [
            { required: true, message: '请选择会员名称', trigger: 'change' }
          ],
          parameterGuid: [
            { required: true, message: '请选择参数配置', trigger: 'change' }
          ],
          repositoryGuid: [
            { required: true, message: '请选择算法名称', trigger: 'change' }
          ],
      },
      multipleSelection: [],
      repositoryTypeList:[],
      repositoryNameList:[],
      parameterList:[],
      tenantList:[],
      parameterSetTitle:'',
      valueType:'',
      cityList:[],
      provinceList:[],
      guid:'',
      tenantGuid:'',
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getrepositoryTypeList();
    // this.getparameterList();
    this.gettenantList();
    this.getAllCityList();
    this.getAllProvinceList(); 
  },
  methods: {
    parameterSet(row){ 
          this.tenantGuid = row.tenantGuid;
          this.getGoodsList();
          this.parameterSetTitle = row.parameter;
          this.valueType = row.valueType;
          this.guid = row.guid; 
          this.ruleForm1.value = '';
          this.ruleForm1.city = [];
          this.dialogVisible = true;
    },
    upDateForm1() {
          let self = this;
          let valueList = [];
          if(self.valueType == '1' || self.valueType == '8'){
                if(self.ruleForm1.value == null || self.ruleForm1.value == ''){
                       self.$message.error("请输入值！");
                       return
                }else{
                       valueList.push(self.ruleForm1.value.toString());
                }
          }else if(self.valueType == '3'){ 
                if(self.ruleForm1.value == null && self.ruleForm1.value == ''){
                       self.$message.error("请选择！");
                       return
                }else{
                       valueList.push(self.ruleForm1.value.toString());
                } 
          }else if(self.valueType == '4'){
                if(self.ruleForm1.city == null && self.ruleForm1.city == ''){
                         self.$message.error("请选择！");
                         return
                  }else{
                         valueList = self.ruleForm1.city;
                  }
          }else if(self.valueType == '6'){
                if(self.ruleForm1.time == null && self.ruleForm1.time == ''){
                         self.$message.error("请选择！");
                         return
                  }else{ 
                         valueList.push(self.$moment(self.ruleForm1.time[0]).format('YYYY-MM-DD'),self.$moment(self.ruleForm1.time[1]).format('YYYY-MM-DD'))
                  }
          }   
          let promise = {
            guid: self.guid,
            tenantGuid:self.tenantGuid,
            // parameterGuid:self.ruleForm.parameterGuid,
            // repositoryGuid:self.ruleForm.repositoryGuid, 
            defaultValue: JSON.stringify(valueList),  // JSON.stringify(
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogVisible = false;
              self.$message.success('参数设置成功');
              self.getData(true);
              self.ruleForm1.value = '';
              self.ruleForm1.city = [];
            } else {
              self.$message.error(res.data.msg);
            }
          }); 
    },
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantName: '',
        repositoryGuid: '', 
        repositoryName: '', 
      };
      self.getData(true);
    },
    getAllCityList() {
      let self = this; 
      self.api.get(`/${serverConfig.msAiAlgorithmService}/sys-conf/all-city/get`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.cityList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getGoodsList() {
      let self = this; 
      let promise = { 
            tenantGuid:self.tenantGuid,
            medCorpName:'哈药'
          };
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/get-import-goods-name`,promise).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.goodsList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getAllProvinceList() {
      let self = this; 
      self.api.get(`/${serverConfig.msAiAlgorithmService}/sys-conf/all-province/get`).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data != null)
            res.data.data.forEach(function(i){
                    let item = {
                      value:i,
                      label:i
                    }
                    self.provinceList.push(item);
            }) 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    gettenantList() {
      let self = this; 
      self.api.postJson(`/${serverConfig.msCustomerService}/tenant/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getrepositoryTypeList() {
      let self = this;
      // self.dto.enterpriseCate = '010201';
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/math-repository/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryNameList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getparameterList(guid) {
      let self = this; 
      self.dto.repositoryGuid = guid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.parameterList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除算法分配成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '算法分配添加';
        self.ruleForm.tenantGuid = '';
        self.ruleForm.tenantName = '';
        self.ruleForm.parameterGuid = '',
        self.ruleForm.parameter = '';
        self.ruleForm.repositoryGuid = '',
        self.ruleForm.repositoryName = '';
        self.ruleForm.state = 'Y';
      } else {
        self.textTitle = '算法分配编辑';
        self.ruleForm.guid = row.guid; 
        self.ruleForm.tenantGuid = row.tenantGuid;
        self.ruleForm.tenantName = row.tenantName;
        self.ruleForm.parameterGuid = row.parameterGuidList;
        self.ruleForm.parameter = row.parameterList;
        self.ruleForm.repositoryGuid = row.repositoryGuid;
        self.ruleForm.repositoryName = row.repositoryName; 
        self.ruleForm.state = row.state;
        self.ruleForm.value = row.value; 
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      if(self.ruleForm.repositoryGuid != null && self.ruleForm.repositoryGuid != ''){
            self.repositoryNameList.forEach(function(i){
                  if(i.guid == self.ruleForm.repositoryGuid){
                        self.ruleForm.repositoryName = i.repositoryName
                  }
            })
      }
      if(self.ruleForm.tenantGuid != null && self.ruleForm.tenantGuid != ''){
            self.tenantList.forEach(function(i){
                  if(i.guid == self.ruleForm.tenantGuid){
                        self.ruleForm.tenantName = i.tenantName
                  }
            })
      }
      if(self.ruleForm.parameterGuid != null && self.ruleForm.parameterGuid != ''){
            self.parameterList.forEach(function(i){
                self.ruleForm.parameterGuid.forEach(function(j){
                  // console.log(self.parameterList,self.ruleForm.parameterGuid);
                  console.log(i.guid,j);
                          if(i.guid == j){
                                self.ruleForm.parameterList.push(i.parameter);
                          }
                }) 
            })
      }
      // return
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = { 
            tenantGuid: self.ruleForm.tenantGuid,
            tenantName: self.ruleForm.tenantName,
            repositoryGuid: self.ruleForm.repositoryGuid,
            repositoryName: self.ruleForm.repositoryName,
            parameterGuidList: self.ruleForm.parameterGuid,
            parameterList:self.ruleForm.parameterList,
            parameter: self.ruleForm.parameter,
            state:self.ruleForm.state
            // value:self.ruleForm.value,
          };
          self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加算法分配成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      if(self.ruleForm.repositoryGuid != null && self.ruleForm.repositoryGuid != ''){
            self.repositoryNameList.forEach(function(i){
                  if(i.guid == self.ruleForm.repositoryGuid){
                        self.ruleForm.repositoryName = i.repositoryName
                  }
            })
      }
      if(self.ruleForm.tenantGuid != null && self.ruleForm.tenantGuid != ''){
            self.tenantList.forEach(function(i){
                  if(i.guid == self.ruleForm.tenantGuid){
                        self.ruleForm.tenantName = i.tenantName
                  }
            })
      }
      if(self.ruleForm.parameterGuid != null && self.ruleForm.parameterGuid != ''){
            self.parameterList.forEach(function(i){
                self.ruleForm.parameterGuid.forEach(function(j){
                          if(i.guid == j){
                                self.ruleForm.parameterList.push(i.parameter);
                          }
                }) 
            })
      }
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.ruleForm.tenantGuid,
            tenantName: self.ruleForm.tenantName,
            repositoryGuid: self.ruleForm.repositoryGuid,
            repositoryName: self.ruleForm.repositoryName,
            parameterGuidList: self.ruleForm.parameterGuid,
            parameterList:self.ruleForm.parameterList,
            parameter: self.ruleForm.parameter,
            state:self.ruleForm.state
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/import-param-val/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑算法分配成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
